export function toFixedDecimals(value, digits=0) {
  let num = Number(value)
  if (num || num === 0) {
    return num.toFixed(digits)
  }
  return value
}

export function toFixedDecimals2(value, digits=0) {
  let num = Number(value)
  if (num && num.toString().indexOf('.') > -1) {
    return Number(num.toFixed(digits))
  }
  return value
}

export function toFixedDecimals3(value, digits=0) {
  let num = Number(value)
  if (num && num.toString().indexOf('.') > -1) {
    if (num >= 100) {
      return Number(num.toFixed(0))
    } else {
      return Number(num.toFixed(digits))
    }
  }
  return value
}

export function convertMetersToMiles(value, digits=0) {
  let num = Number(value)
  if (num || num === 0) {
    return (num / 1609.344).toFixed(digits)
  }
  return ''
}

export function capitalizeFirstLetter(value) {
  value = (value || '').toString().trim().toLowerCase()
  return value.replace(value[0], value[0].toUpperCase())
}

// 千分位展示
export function toThousandFilter(num) {
  if (!isNaN(parseFloat(num))) {
    return num.toString().replace(/^-?\d+/g, m => m.replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,'))
  }
  return num
}

export function formatPhone(phone) {
  // phone --string
  const num = (phone || '').toString().replace(/[^\d]/g, '')
  const s = num
      .match(/(\d{3})?(\d{3})?(\d{4})?(\d*)/i)
      .slice(1)
      .filter(v => v)
  const c = s.slice(0, 3)
  const r = s.slice(3)
  let str = c[0] ? '(' + c[0] + (c[1] ? ')' + ' ' + c[1] + (c[2] ? '-' + c[2] : '') : '') : ''
  return r ? str + r : str
}